<section class="faqs-container">
    <div class="card">
        <div class="card-body">
            <h1 class="card-title h5">Frequently Asked Questions</h1>
            <div>
                <h6 class="font-weight-bold">How I subscribe? </h6>
                <p class="mb-0">You can subscribe to ' Swipe & Win' service by:</p>
                <ul class="text-black-50 pl-3">
                    <li>Following the link via XXX app menu</li>
                    <li>Visit website</li>
                    <li>Dial XXX from your mobile number</li>
                    <li>Send SUB to XXX from your mobile number</li>
                </ul>

                <h6 class="font-weight-bold">What is the duration of the service?</h6>
                <p>The service has annual duration.</p>

                <h6 class="font-weight-bold">What are the prizes? </h6>
                <p class="mb-0">Swipe & Win service gives away:</p>
                <ul class="text-black-50 pl-3">
                    <li>XXMB once upon scoring 10 or more correct questions</li>
                    <li>XXX USD in Cash every day</li>
                    <li>XXX USD in Cash every week</li>
                    <li>XXX USD in Cash every month</li>
                </ul>

                <h6 class="font-weight-bold">If I win, how will I be informed?</h6>
                <p>The winner will be contacted by Operator in the next days as to explain the process
                    needed. So do not worry, just keep your phone on.</p>

                <h6 class="font-weight-bold">How many times may I win each prize? </h6>
                <p>Each user is eligible to win the daily prize unlimited times and rest prizes only once.
                </p>


                <h6 class="font-weight-bold">What are the Swipe & Win game rules? </h6>
                <ul class="text-black-50 pl-3">
                    <li>Each game lasts for 55 seconds.</li>
                    <li>Each question is consisted of a statement and a photo.</li>
                    <li>User has to Swipe right for Correct or left for Wrong.</li>
                    <li>Be careful! Every wrong reply deducts 5 seconds from the remaining time!</li>
                    <li>During a game round, special questions may also be served such as bronze, silver and golden
                        ones.</li>
                </ul>

                <h6 class="font-weight-bold">Does my Swipe & Win credits expire? </h6>
                <p>Both awarded and purchased Swipe & Win credits expire at the end of calendar day if not
                    consumed until then.
                </p>

                <h6 class="font-weight-bold">I consume my daily credit; can I add more?</h6>
                <p>You can purchase a bundle of 3 Swipe & Win credits only for XXX USD upon consuming your
                    available daily credit. Each user may play up to 5 extra rounds per day.
                </p>

                <h6 class="font-weight-bold">How can I unsubscribe? </h6>
                <p>To cancel your ' Swipe & Win' subscription, send 'STOP' to the short code XXX.
                </p>

                <h6 class="font-weight-bold">I’m not an “Operator” subscribe; may I participate to the service? </h6>
                <p>No, if you are not an xxx subscriber unfortunately you cannot subscribe to the service.
                </p>
            </div>
        </div>
    </div>
</section>